import { Play, Instagram } from 'lucide-react';

const YT = ({ id, title }) => (
  <iframe
    data-testid="reel-youtube"
    src={`https://www.youtube.com/embed/${id}?rel=0&modestbranding=1&playsinline=1`}
    title={title}
    className="absolute inset-0 w-full h-full"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerPolicy="strict-origin-when-cross-origin"
    allowFullScreen
  />
);

const IG = ({ id, title }) => (
  <iframe
    data-testid="reel-instagram"
    src={`https://www.instagram.com/p/${id}/embed/`}
    title={title}
    className="absolute inset-0 w-full h-full bg-white"
    scrolling="no"
    allow="encrypted-media"
    allowFullScreen
  />
);

const Video = ({ src, poster, title }) => (
  <video
    data-testid="reel-video"
    src={src}
    poster={poster}
    controls
    playsInline
    preload="metadata"
    aria-label={title}
    className="absolute inset-0 w-full h-full object-cover bg-ink"
  />
);

const LinkOut = ({ href, poster, title }) => (
  <a
    href={href}
    target="_blank"
    rel="noreferrer"
    data-testid="reel-link"
    aria-label={`${title} — watch on Instagram`}
    className="group absolute inset-0 block"
  >
    <img src={poster} alt="" className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-ink/30 group-hover:bg-ink/45 transition-colors" />
    <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 rounded-full bg-butter text-ink border border-ink flex items-center justify-center group-hover:scale-105 transition-transform">
      <Play size={24} className="ml-1" />
    </span>
    <span className="absolute bottom-4 inset-x-0 flex justify-center">
      <span className="inline-flex items-center gap-2 bg-cream text-ink text-[10px] font-bold uppercase tracking-[0.2em] px-3 py-1.5 rounded-full border border-ink">
        <Instagram size={12} /> Watch on Instagram
      </span>
    </span>
  </a>
);

export const ReelPlayer = ({ reel, title, className = 'relative' }) => (
  <div data-testid="case-reel-player" className={`bg-ink overflow-hidden ${className}`}>
    {reel.type === 'youtube' && <YT id={reel.id} title={title} />}
    {reel.type === 'instagram' && <IG id={reel.id} title={title} />}
    {reel.type === 'mp4' && <Video src={reel.src} poster={reel.poster} title={title} />}
    {reel.type === 'link' && <LinkOut href={reel.href} poster={reel.poster} title={title} />}
  </div>
);
